import { Box, Checkbox } from "@chakra-ui/react";

import { CheckboxOptionType } from "./types";

type CheckboxOptionProps<T extends string> = CheckboxOptionType<T> & {
  name: string;
  checked?: boolean;
  onChangeValue: (value: boolean) => void;
};

export const CheckboxOption = <T extends string>({
  name,
  value,
  label,
  description,
  onChangeValue,
  checked,
  disabled,
}: CheckboxOptionProps<T>) => {
  return (
    <Box _hover={{ backgroundColor: "gray.100" }} borderRadius="md">
      <Checkbox.Root
        name={name}
        id={`${name}_${value}`}
        checked={checked}
        disabled={disabled}
        onCheckedChange={e => onChangeValue(!!e.checked)}
        px={4}
        py={2}
        width="100%"
        cursor={"pointer"}
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control
          width="18px"
          height="18px"
          position="relative"
          _checked={{ borderColor: "blue.500", backgroundColor: "blue.500" }}
          _disabled={{
            backgroundColor: "gray.200",
            _checked: { color: "gray.900", borderColor: "gray.300", backgroundColor: "gray.300" },
          }}
          borderWidth={2}
        >
          <Checkbox.Indicator position="absolute" inset={0} />
        </Checkbox.Control>

        <Box>
          <Checkbox.Label>{label}</Checkbox.Label>
          {description && (
            <Box textStyle="sm" color="gray.400">
              {description}
            </Box>
          )}
        </Box>
      </Checkbox.Root>
    </Box>
  );
};
